module.exports = __webpack_public_path__ + "img/selected7-min.4507da3d.png";